module.exports = __webpack_public_path__ + "img/icon-14.49d70d43.png";